<template>
    <div class="p-4 mb-4 bg-white border shadow-lg dark:border-gray-200 dark:border dark:bg-gray-800 md:flex rounded-3xl border-clay-200">

        <a :href="`/${character.urlSlug}`" :alt="character.showTitle" :title="character.showTitle"
            class="shrink-0 guide-img-container">
            <img class="object-cover w-20 h-20 mx-auto md:w-32 md:h-32 rounded-3xl" :src="character.showLogo" :alt="`${character.showTitle} logo`" 
                    :title="`${character.showTitle} logo`">
        </a>


        <div class="justify-between flex-1 ml-4 md:flex md:flex-col">
            <div class="items-center flex-none mb-2">

                <a :href="`/${character.urlSlug}`" :alt="character.showTitle" :title="character.showTitle"
                    class="inline-block text-sm font-medium text-gray-900 text-md hover:underline hover:decoration-slate-900 hover:transition-all hover:decoration-2 md:block">
                    <h3 class="">{{ character.name }}</h3>
                </a>
                <p>
                    <em class="text-sm text-gray-900 ">
                        <span class="tag-list">
                            <span class="sr-only">
                                {{ character.roleSize }},{{ character.ageRanges?.join(',') }} {{ character.gender }}, {{
                                character.vocalParts?.join(',') }} {{ character.dancingLevel }} {{ character.ageRanges?.join(',') }}
                            </span>

                        </span>
                    </em>
                </p>
                <p><a :href="`/${character.showId}`" :alt="character.showTitle" :title="character.showTitle"
                        class="text-sm text-slate-800">{{ character.showTitle }}</a>
                </p>
            </div>
            <div class="justify-between sm:flex">
                <div class="mr-4"></div>
                <div>
                    <div class="mt-2 ml-4 shrink-0 md:mt-0 md:pull-right md:float-right">
                        <div class="grid grid-cols-2 mt-4 space-x-1 text-sm text-center sm:text-left sm:mt-0">
                            <fanning :id="character.id" :number-of-fans="character.fanCount"></fanning>
                            <Bookmarking :id="character.id"></Bookmarking>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>











<script lang="ts" setup>
// @ts-ignore
import {defineProps} from "vue";
import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {CharacterDto} from "@/dtos";

const props = defineProps<{
    character: CharacterDto
}>();

const character: CharacterDto = props.character;

</script>
<style>

</style>